<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 25 25"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
    stroke-width="1.5"
  >
    <path
      d="M11.559 7.118a2.348 2.348 0 1 0 0-4.696 2.348 2.348 0 0 0 0 4.696ZM11.559 17.245v4.926c0 .599-.46 1.059-1.059 1.059-.598 0-1.059-.46-1.059-1.059v-5.386"
    />
    <path
      d="M13.63 17.706v4.465c0 .599-.46 1.06-1.058 1.06-.598 0-1.059-.461-1.059-1.06v-4.925M14.92 9.327v4.604M8.153 12.457v-2.67a2.623 2.623 0 0 1 2.624-2.623h1.519c.506 0 .967.138 1.335.368M9.441 16.509a3.21 3.21 0 0 1-1.15-1.657"
    />
    <path
      d="m13.63 7.532 4.097-3.867a1.028 1.028 0 0 1 1.474 0 1.028 1.028 0 0 1 0 1.473l-4.282 4.235M23.344 8.223c-.184-.23-.46-.322-.783-.276l-3.774.322a.928.928 0 0 0-.829 1.013.929.929 0 0 0 1.013.828l.966-.092-6.168 5.386-3.407-3.729a.89.89 0 0 0-1.289-.046l-.92.829-5.939 5.432a.89.89 0 0 0-.046 1.289c.184.184.415.322.69.322.231 0 .461-.092.6-.23l6.122-5.616 3.406 3.683c.323.368.921.414 1.29.092l6.997-6.123-.139.829a.898.898 0 0 0 .737 1.059h.184a.94.94 0 0 0 .92-.737l.6-3.453c.045-.276-.047-.552-.23-.782Z"
    />
  </svg>
</template>
